export default __webpack_public_path__ + "static/cloud_icon_gray-59d138f1ade3ffaac4629da26ad8daa5.png";